import React from "react";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { useNavigate } from "react-router-dom";
import { clearListuser } from "../../Redux/Slices/User/ListUserSlice";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import { clearDashboardChart } from "../../Redux/Slices/DashboardChart/DashboardChart";
import IconButtonField from "../Button/IconButtonField";
import Avatars from "../Avatar/Avatars";
import Menus from "../Menu/Menu";

import { listUser } from "../../Redux/Slices/User/ListUserSlice";
import { dashboardChart } from "../../Redux/Slices/DashboardChart/DashboardChart";

const UserProfileSection = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const { data: ListUserSliceLoading } = useAppSelector(
        (state) => state.ListUserSlice
    );

    const { data: DashboardCards } = useAppSelector(
        (state) => state.DashboardChart
    );

    React.useEffect(() => {
        if (!ListUserSliceLoading?.data) {
            dispatch(listUser());
        }
        if (!DashboardCards?.data) {
            dispatch(dashboardChart());
        }
    }, [dispatch, ListUserSliceLoading?.data, DashboardCards?.data]);

    const ListUser: any = Array.isArray(ListUserSliceLoading?.data)
        ? ListUserSliceLoading?.data
        : [];

    const Dashboarduser: any = DashboardCards?.data;

    return (
        <div style={{ display: "flex", alignItems: "center" }}>
            <Menus
                menuItems={[
                    {
                        menu: "Logout",
                        onClick: () => {
                            sessionStorage.clear();
                            dispatch(clearListuser());
                            dispatch(clearLoginStatus());
                            dispatch(clearDashboardChart());
                            navigate("/login");
                        },
                    },
                ]}
            >
                <IconButtonField onClick={() => { }}>
                    <Avatars sx={{ height: "2rem", width: "2rem" }} />
                </IconButtonField>
            </Menus>

            {/* Username + SubscriptionStatus stacked vertically */}
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: "8px",
                    alignItems: "flex-start",
                }}
            >
                <span className="Username" style={{ padding: "0", margin: "0" }}>
                    {ListUser?.[0]?.student_name}
                </span>
                {Dashboarduser?.is_subscribed ? (
                    <span className="SubscriptionStatus" style={{ padding: "0" }}>
                        Premium
                    </span>
                ) : (
                    <span className="SubscriptionStatus" style={{ padding: "0" }}>
                        Free Plan
                    </span>
                )}
            </div>
        </div>
    );
};

export default UserProfileSection;
